/* eslint-disable no-param-reassign */
import ApiManager from '../api/crud-manager';
import RegisterAccount from './my-account/RegisterAccount';

class KvkCheck {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('.js-kvk-check'),
      registerFormInput: (module, inputName) => module.querySelector(`[name="${inputName}"]`),
      microServiceSettings: {
        company: 'aircomponents',
        url: 'https://microservice-kvk-live.pangaea19.nl/api/v1/kvk/company',
        testUrl: 'https://microservice-kvk.pangaeatest.nl/api/v1/kvk/testcompany'
      },
      ...options
    };
    this.apiManager = new ApiManager();
  }

  async hasCompanyAccount(kvkNumber) {
    const api = this.apiManager;
    const url = `/api/v1/aircomponents/verifycoc?cocNumber=${kvkNumber}`;
    return api
      .get(url)
      .then(data => data)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('getCompanyAccount from request failed', error);
        return null;
      });
  }

  async getCompany(kvkNumber) {
    const api = this.apiManager;
    const { microServiceSettings } = this.config;

    if (!microServiceSettings) return null;

    const { url, company } = microServiceSettings;
    const apiUrl = `${url}/${company}/${kvkNumber}`;

    return api
      .get(apiUrl)
      .then(data => data)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('getCompany from request failed', error);
        return null;
      });
  }

  autofillForm(addressObject) {
    const { module } = this.config;

    const inputs = module.querySelectorAll('[data-field]');
    inputs.forEach(input => {
      const { field } = input.dataset;
      const ignoreFields = ['kvkNumber', 'sbImatched'];

      if (!ignoreFields.includes(field)) {
        const value = addressObject[field];

        input.value = value;

        if (value && value.length) {
          input.setAttribute('readonly', true);
        }
      }
    });
  }

  enableAccountRegister(type) {
    const { module, registerFormInput } = this.config;

    const passwordFields = module.querySelector('[data-module="passwords"]');
    if (passwordFields && type === 'register-account') {
      passwordFields.classList.remove('hidden');
      const inputs = passwordFields.querySelectorAll('input');
      inputs.forEach(input => {
        input.setAttribute('data-parsley-required', '');
      });
    } else if (passwordFields && !passwordFields.classList.contains('hidden')) {
      passwordFields.classList.add('hidden');
      const inputs = passwordFields.querySelectorAll('input');
      inputs.forEach(input => {
        input.removeAttribute('data-parsley-required');
      });
    }

    const submitButtons = module.querySelectorAll('[data-submit]');
    submitButtons.forEach(submitButton => {
      if (submitButton.dataset.submit === type) {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('hidden');

        // add trigger to register account module if sbi code matched
        if (type === 'register-account') {
          submitButton.addEventListener('click', event => {
            event.preventDefault();
            const emailInput = registerFormInput(module, 'emailAddress');
            const userNameInput = registerFormInput(module, 'username');
            if (emailInput && userNameInput) {
              userNameInput.value = emailInput.value;
            }
            new RegisterAccount().submitForm(module);
          });
        }
      } else {
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('hidden');
      }
    });
  }

  displayAlert(type, datasetName) {
    const { module } = this.config;

    const alertModule = module.querySelector('[data-module="alert"]');

    alertModule.className = '';
    alertModule.classList.add('alert', `alert-${type}`);
    alertModule.innerHTML = alertModule.dataset[datasetName];
  }

  static enableDeliveryAddress(enabled) {
    const element = document.querySelector('[data-child-module="CheckboxOtherAddress"]');
    const formElement = document.querySelector('.js-checkboxotheraddress-target');
    if (!element || !formElement) return;
    element.classList.toggle('hidden', !enabled);
    formElement.classList.toggle('hidden', !enabled);
  }

  async verifyKvkNumber(kvkNumber) {
    const { module, registerFormInput } = this.config;

    const kvkInputField = module.querySelector('[data-field="kvkNumber"]');
    const kvkCheckInputField = registerFormInput(module, 'kvkCheck');
    let kvkAccountExists = false;

    // add loading
    kvkInputField.setAttribute('readonly', true);
    module.classList.add('is-loading');

    // function to remove disable from all form inputs
    const resetDisabledInputs = () => {
      const inputs = module.querySelectorAll('[data-field]');
      inputs.forEach(input => {
        input.removeAttribute('readonly');
      });
    };

    // check if account with kvk already exists
    await this.hasCompanyAccount(kvkNumber).then(result => {
      kvkInputField.removeAttribute('readonly');
      module.classList.remove('is-loading');
      kvkAccountExists = result;

      if (!kvkAccountExists) {
        return;
      }

      this.displayAlert('danger', 'accountExists');
      // this.enableAccountRegister('account-exists');
    });

    if (!kvkAccountExists) {
      // api class
      await this.getCompany(kvkNumber).then(result => {
        // remove loading
        kvkInputField.removeAttribute('readonly');
        module.classList.remove('is-loading');

        // check if object has data
        if (result && Object.keys(result).length > 0) {
          this.autofillForm(result);
          const sbiMatched = (result.sbImatched || '').toLowerCase();
          // enable registration if sbi code matched with requirements
          if (sbiMatched === 'sbi_ok') {
            this.displayAlert('success', 'registerAccount');
            if (kvkCheckInputField) {
              kvkCheckInputField.value = 'true';
            }
            // this.enableAccountRegister('register-account');
          } else if (sbiMatched === 'sbi_not_ok') {
            this.displayAlert('info', 'requestAccount');
            if (kvkCheckInputField) {
              kvkCheckInputField.value = 'false';
            }
          } else {
            this.displayAlert('info', 'noData');
            if (kvkCheckInputField) {
              kvkCheckInputField.value = 'false';
            }
            resetDisabledInputs();
          }
        } else {
          this.displayAlert('warning', 'error');
          if (kvkCheckInputField) {
            kvkCheckInputField.value = 'false';
          }
          resetDisabledInputs();
        }
      });
    }
  }

  isForeignCountry() {
    const { module } = this.config;

    const countryInputField = module.querySelector('[name="country"]');
    const value = countryInputField ? countryInputField.value.toLowerCase() : '';

    return value === 'be' || value === 'de';
  }

  hideAlert() {
    const { module } = this.config;

    const alertModule = module.querySelector('[data-module="alert"]');
    if (!alertModule) return;

    alertModule.className = 'hidden';
    alertModule.innerHTML = '';
  }

  init() {
    const { module, registerFormInput } = this.config;
    if (!module) return;

    const handleBlur = event => {
      const { target } = event;

      if (!target.value || this.isForeignCountry()) return;

      const { maxLength, value } = target;

      // validation
      if (!/^\d+$/.test(value) || (maxLength && value.length !== maxLength)) {
        this.displayAlert('danger', 'invalidError');
      }
    };

    const handleInput = event => {
      const { target } = event;

      if (this.isForeignCountry()) return;

      // any change to the kvk number invalidates the previous check result
      // until a fresh lookup confirms this exact value (AIR-897)
      const kvkCheckInputField = registerFormInput(module, 'kvkCheck');
      if (kvkCheckInputField) {
        kvkCheckInputField.value = 'false';
      }

      if (!target.value) return;

      const { maxLength, value } = target;

      // trigger api
      if (/^\d+$/.test(value) && (!maxLength || value.length === maxLength)) {
        this.verifyKvkNumber(value);
      }
    };

    const bindEvents = input => {
      input.addEventListener('input', handleInput);
      input.addEventListener('blur', handleBlur);
    };

    const kvkInputField = module.querySelector('[data-field="kvkNumber"]');

    if (!kvkInputField) return;
    bindEvents(kvkInputField);

    const countryInputField = module.querySelector('[name="country"]');
    countryInputField.addEventListener('change', e => {
      const { value } = e.target;
      if (!value) return;
      const parentElement = kvkInputField.closest('.form-group');
      if (!parentElement) return;
      const kvkCheckInputField = registerFormInput(module, 'kvkCheck');
      if (value.toLowerCase() === 'nl') {
        parentElement.classList.remove('hidden');
        kvkInputField.setAttribute('data-parsley-required', '');
        kvkInputField.setAttribute('maxlength', '8');
        // a kvk check performed under a different country selection (e.g. BE/DE) must not
        // carry over: NL always requires its own fresh kvk + sbi validation (AIR-897)
        if (kvkCheckInputField) {
          kvkCheckInputField.value = 'false';
        }
        const sbiCodeField = registerFormInput(module, 'sbiCode');
        if (sbiCodeField) {
          sbiCodeField.value = '';
        }
        this.hideAlert();
      } else if (value.toLowerCase() === 'be' || value.toLowerCase() === 'de') {
        parentElement.classList.remove('hidden');
        kvkInputField.removeAttribute('data-parsley-required');
        kvkInputField.removeAttribute('maxlength');
        kvkInputField.removeAttribute('readonly');
        const sbiCodeField = registerFormInput(module, 'sbiCode');
        if (sbiCodeField) {
          sbiCodeField.value = '';
        }
        if (kvkCheckInputField) {
          kvkCheckInputField.value = 'true';
        }
        this.hideAlert();
      } else {
        parentElement.classList.add('hidden');
        kvkInputField.removeAttribute('data-parsley-required');
        if (kvkCheckInputField) {
          kvkCheckInputField.value = 'false';
        }
        this.enableAccountRegister('request-account');
      }
    });
  }
}

export default KvkCheck;
